import dbConnect from 'db/dbConnect'
import { getEssentials, getSalonBySubdomain } from 'db/repo/listAdsSalon/getSalonData'
import { salonMap } from 'lib/offer/offerMap'
import { salonOffersView, salonView } from 'lib/offer/offerView'
import { salonPageProps } from 'lib/salon/salonPage'

export { default } from '@components/salon/SalonComponent'

const HOST = process.env.HOST

export async function getServerSideProps (context) {
    const { query: { subdomain }} = context

    await dbConnect()

    const [salon, redirect, temporary] = await getSalonBySubdomain(subdomain)

    if (temporary) return { redirect: { permanent: false, destination: redirect } }

    if (redirect || !salon) {
        // parametry (zakładka, strona) zostają przy przekierowaniu na nową nazwę wizytówki
        const { subdomain: _, ...rest } = context.query
        const params = new URLSearchParams(Object.entries(rest).flatMap(([k, v]) => [].concat(v).map(x => [k, x]))).toString()
        const target = redirect || HOST
        return {
            redirect: {
                permanent: true,
                destination: params && target !== HOST ? `${target}/?${params}` : target,
            }
        }
    }

    if (!salon.is_partner) {
        const props = await salonPageProps(context, salon.toObject(), subdomain)
        return props ? { props } : { notFound: true }
    }

    const props = await getEssentials(context, salon, subdomain)

    return {
        props: {
            ...props,
            map: await salonMap(props.salon),
            salon: salonView(props.salon),
            prefetchedOffers: salonOffersView(props.prefetchedOffers),
        },
    }
}